import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import { STORAGE, SUPPORT_LINKS } from "../constants";
import { LocalStorageService } from "../services/LocalStorageService";
import { AppContext } from "../context/AppContext";
import { useCurrentAccount } from "../hooks/useCurrentAccount";
import ModalSupport from "./ModalSupport";
import SelectLanguage from "./SelectLanguage";
import { useTranslation } from "react-i18next";
import ThemeDropdown from "../components/ThemeDropdown";

function Header() {

    const { t } = useTranslation();

    const { setSupport } = useContext(AppContext);

    const navigate = useNavigate();
    const location = useLocation();

    const { account } = useCurrentAccount();

    const session = useMemo(() => LocalStorageService.get(STORAGE.SESSION), [])

    const [modalSupport, setModalSupport] = useState(false)
    const [supportData] = useState(LocalStorageService.get(STORAGE.SUPPORT_DATA))
    const [supportLinks, setSupportLinks] = useState([])

    const logout = () => {
        LocalStorageService.clear();
        navigate('/auth/login')
    }

    useEffect(() => {
        if (!account) logout()
    }, [account])

    useEffect(() => {

        if (location.pathname.startsWith('/reports/tickets')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.REPORTES_TICKETS)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/reports/agents')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.REPORTES_AGENTES)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/reports/payments')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.REPORTES_PAGOS)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/reports/customers')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.REPORTES_CLIENTES)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/reports/chatbot')) {
            // const links = supportData.filter( l => l.module_key === SUPPORT_LINKS.REPORTES_TICKETS)
            setSupportLinks([])
        }
        else if (location.pathname.startsWith('/bd-clients')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.BASECLIENTES)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/bulk-senders')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.ENVIOMASIVO)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/configuration')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.CONFIGURACION)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/channels')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.CANALES)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/users')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.USUARIOS)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/payments')) {
            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.PAGOS)
            setSupportLinks(links)
        }
        else if (location.pathname.startsWith('/bot')) {

            const links = supportData.filter(l => l.module_key === SUPPORT_LINKS.CHATBOT)
            setSupportLinks(links)
        }
    }, [location.pathname])


    return (
        <>
            <header id="header" className="navbar navbar-expand-lg navbar-fixed navbar-container navbar-bordered bg-white">
                <div className="navbar-nav-wrap">

                    <a className="navbar-brand" href="../index.html" aria-label="Front">
                        <img className="navbar-brand-logo" src="/assets/img/logo.png" alt="Logo" data-hs-theme-appearance="default" />
                        <img className="navbar-brand-logo-mini" src="/assets/svg/logos/logo-short.svg" alt="Logo" data-hs-theme-appearance="default" />
                    </a>
                    <div className="navbar-nav-wrap-content-start">

                        <button type="button" className="js-navbar-vertical-aside-toggle-invoker navbar-aside-toggler">
                            <i className="bi-arrow-bar-left navbar-toggler-short-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Collapse"></i>
                            <i className="bi-arrow-bar-right navbar-toggler-full-align" data-bs-template='<div class="tooltip d-none d-md-block" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' data-bs-toggle="tooltip" data-bs-placement="right" title="Expand"></i>
                        </button>
                    </div>


                    <div className="navbar-nav-wrap-content-end">

                        <ul className="navbar-nav">
                            <li className="nav-item d-none d-sm-inline-block">

                                <div className="dropdown">
                                    <button type="button" className="btn btn-ghost-primary btn-sm text-white-dark" id="navbarNotificationsDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation>
                                        <i className="bi-life-preserver me-1 text-primary fw-bolder"></i>  ¿Necesitas ayuda?
                                    </button>

                                    <div className="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="navbarNotificationsDropdown" style={{ width: '20rem' }}>
                                        <div className="card">

                                            <div className="card-header card-header-content-between">
                                                <h4 className="card-title mb-0"><i className="bi-life-preserver me-2"></i>  Ayuda  </h4>
                                            </div>


                                            <div className="card-body">

                                                {
                                                    supportLinks.map(s => (
                                                        <div key={s.id} className="dropdown-item cursor-pointer" onClick={() => setSupport({ title: s.title, link: s.url, show: true })}>
                                                            {s.title}
                                                        </div>
                                                    ))
                                                }

                                                {supportLinks.length > 0 && <div className="dropdown-divider"></div>}

                                                <div className="dropdown-item cursor-pointer" onClick={() => setModalSupport(true)}>
                                                    Hablar con un asesor <i className="bi-box-arrow-up-right ms-2"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>

                            <li className="nav-item">
                                <SelectLanguage />
                            </li>

                            <li className="nav-item">
                                <div className="dropdown">
                                    <a className="navbar-dropdown-account-wrapper bg-soft-info" href="#" id="accountNavbarDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation style={{ backgroundColor: 'rgba(10,89,95,.1)' }}>
                                        <span className="avatar avatar-sm avatar-primary avatar-circle">
                                            <span className="avatar-initials">{(session.name || session.user_name)[0]}</span>
                                        </span>

                                        <span className="mx-2">{account?.nombre}</span>
                                    </a>
                                    <div
                                        aria-labelledby="accountNavbarDropdown"
                                        className="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account"
                                        style={{
                                            opacity: "1",
                                            width: "16rem",
                                        }}>
                                        <div className="dropdown-item-text">
                                            <div className="d-flex align-items-center">
                                                <span className="avatar avatar-sm avatar-primary avatar-circle">
                                                    <span className="avatar-initials">{(session.name || session.user_name)[0]}</span>
                                                </span>
                                                <div className="flex-grow-1 ms-3">
                                                    <h5 className="mb-0">{session.name || session.user_name}</h5>
                                                    <p className="card-text text-body">{account?.nombre}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="dropdown-divider" />
                                        <span className="text-uppercase dropdown-header">Configuración</span>
                                        <a className="dropdown-item" onClick={() => navigate('/select-account')}>
                                            <i className="bi bi-people-fill me-2 fs-4 text-primary fw-bolder" />
                                            {t("header.switch-btn")}
                                        </a>
                                        <span className="text-uppercase dropdown-header">Apariencia</span>
                                        <ThemeDropdown />
                                        <div className="dropdown-divider" />
                                        <a className="dropdown-item" onClick={logout}>
                                            <i className="bi bi-box-arrow-right me-2 fs-4 text-danger fw-bolder" />
                                            {t("header.logout-btn")}
                                        </a>
                                    </div>
                                </div>

                            </li>
                        </ul>

                    </div>

                </div>
            </header>

            <ModalSupport
                show={modalSupport}
                onRequestClose={() => setModalSupport(false)}
            />
        </>
    )
}

export default Header